import AnalyticsHelper from '../../utils/analytics-helper';

export default class CarPreselect {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el;
        this.data = parent.data;
        this.car = parent.car;
        this.pricing = parent.pricing;
        this.hashManager = parent.hashManager;
        this.carManager = parent.carManager;
        this.validator = parent.validator;
        this.stockChecker = parent.stockChecker;
    }

    preselect() {
        let preselectCar;
        let validate;
        let hasCar = false;
        let isValid = true;

        if(this.hashManager.has('mtoce')){
            this.car.fromMTOCE();
            hasCar = true;
        } else if(this.hashManager.has('id')) {
            this.car.fromUrl();
            hasCar = true;
        }

        if(hasCar) {
            preselectCar = this.car.clone();
            validate = this.validate();
            if(!validate.valid) {
                this.carManager.validateAndResolveConflicts(this.car, null, null, false, true);
                if(!validate.silent) { isValid = false; }
            }
        }
        
        validate = this.validate();
        if (!validate.valid && this.stockChecker.enabled && this.data.stock.length > 0) {
            this.car.fromMTOC(this.data.stock[0]);
            this.carManager.validateAndResolveConflicts(this.car, null, null, false, true);
            if(!validate.silent) { isValid = false; }
        }

        validate = this.validate();
        if(!validate.valid) {
            this.car.fromData(this.data.cars[0]);
            this.carManager.validateAndResolveConflicts(this.car, null, null, false, true);
            if(!validate.silent) { isValid = false; }
        }

        if(hasCar && !isValid) {
            this.parent.preselectModal.show(preselectCar);
        }

        this.car.toUrl();
        this.parent.update();
        this.analyticsPush();
    }

    validate() {
        return this.validator.validate(this.car);
    }

    async analyticsPush() {
        await this.pricing.getMTOCEPricing();

        const documentCountryCode = document.querySelector('html').getAttribute('country');
        const model = this.data?.model.modelBodyCode;
        const totalPrice = this.pricing?.getCarTotalPrice();
        const mtoce = this.car?.mtoce();
        const selectedGrade = this.car?.grade;
        const selectedColour = this.car?.colour;

        AnalyticsHelper.push({ ecommerce: null }); // Clear the previous ecommerce object.
        AnalyticsHelper.push({
            event: 'view_item',
            actionType: 'ecommerce - view item',
            businessUnit: 'cars',
            moduleName: 'ecommerce',
            clickText: '',
            clickType: '',
            destinationURL: '',
            modelSelected: model,
            inPageLocation: '',
            countryCode: documentCountryCode,
            ecommerce: {
                currency: window.HONDA?.currency?.ISO,
                value: totalPrice,
                items: [
                    {
                        item_id: mtoce,
                        item_name: model,
                        discount: 0,
                        index: 0,
                        item_brand: 'HONDA',
                        gradeName: selectedGrade,
                        colourName: selectedColour,
                        dealerName: '',
                        price: totalPrice,
                        quantity: 1,
                    },
                ],
            },
        });
    }
}